import { useQuery } from '@apollo/client';

import { CURRENT_USER_DJ } from '../graphql/query/currentUserDjQuery.graphql';

export const useCurrentUserDjQuery = (eventId?: string | null) => {
  return useQuery(CURRENT_USER_DJ, {
    variables: eventId ? { eventId } : undefined,
    skip: !eventId,
  });
};
